const ActionTypes = {
  // General
  SHOW_ALERT: "SHOW_ALERT",
  HIDE_ALERT: "HIDE_ALERT",
  SHOW_LOADING: "SHOW_LOADING",
  SHOW_UPLOADING_LOADING: "SHOW_UPLOADING_LOADING",
  HIDE_UPLOADING_LOADING: "HIDE_UPLOADING_LOADING",
  HIDE_LOADING: "HIDE_LOADING",
  GENERAL_TYPES: "GENERAL_TYPES",
  SESSION_EXPIRED:"SESSION_EXPIRED",
  CHANGE_THEME: "CHANGE_THEME",

 
  // User
  GET_USER: "GET_USER",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  IsLogin: "IsLogin",
  IsLogout: "IsLogout",

  // Snippet
  GET_SNIPPETS: "GET_SNIPPETS",
  CLEAR_SNIPPETS: "CLEAR_SNIPPETS",

  GET_MY_SNIPPETS: "GET_MY_SNIPPETS",
  CLEAR_MY_SNIPPETS: "CLEAR_MY_SNIPPETS",

  GET_SNIPPET_DETAIL: "GET_SNIPPET_DETAIL",
  CLEAR_SNIPPET_DETAIL: "CLEAR_SNIPPET_DETAIL",

  DELETE_SNIPPET: "DELETE_SNIPPET",

  GET_SEARCHED_VALUE: "GET_SEARCHED_VALUE",
  CLEAR_SEARCHED_VALUE: "CLEAR_SEARCHED_VALUE",

  
};

export default ActionTypes;
